"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WEBSOCKET_TYPE_NAME = exports.TOKEN_MANAGEMENT_EXTENSION = void 0;
var properties = {
  servletPath: 'amb',
  logLevel: 'info',
  loginWindow: 'true',
  wsConnectTimeout: 10000,
  overlayStyle: '',
  pruneFailedTransports: 'true',
  subscribeCommandsFlow: {
    /* glide.amb.client.subscribe.commands.flow.* ... */
    enable: false,
    maxInflight: 1,
    maxWait: 10000,
    retries: 3,
    retryDelay: {
      min: 2000,
      max: 300000,
      increaseFactor: 2
    }
  },
  redeliveryDisconnectTimeoutInMins: 10,
  requestHeaderToClearStickySessionCookie: true
};
var WEBSOCKET_TYPE_NAME = 'websocket';
exports.WEBSOCKET_TYPE_NAME = WEBSOCKET_TYPE_NAME;
var TOKEN_MANAGEMENT_EXTENSION = "tokenManagementExtension";
exports.TOKEN_MANAGEMENT_EXTENSION = TOKEN_MANAGEMENT_EXTENSION;
var _default = properties;
exports.default = _default;